export const SET_JWT_DATA = 'auth/SET_JWT_DATA';
export const SET_USER_PROFILE = 'auth/SET_USER_PROFILE';
export const SET_SELECTED_CLIENT = 'auth/SET_SELECTED_CLIENT';
export const SET_DATA_LOADED = 'auth/SET_DATA_LOADED';
export const SET_ACCESS_ALLOWED = 'auth/SET_ACCESS_ALLOWED';
export const SET_CLIENT_TO_CHECK_ON_LOAD = 'auth/SET_CLIENT_TO_CHECK_ON_LOAD';
